import { roundedAvatarStyles } from './RoundedAvatar.styles';
import { squaredAvatarStyles } from './SquaredAvatar.styles';
export const avatarVariantStyles = {
    rounded: roundedAvatarStyles,
    squared: squaredAvatarStyles,
};
